import React, { useCallback, useState } from 'react'
import { Flex, Box } from 'reflexbox/styled-components'
import { Formik } from 'formik'

import Card from 'components/Card'
import Button from 'components/Button'
import Loader from 'components/Loader'
import { TextField } from 'components/Form/Fields'
import { SemiTitle, Text } from 'components/Typography'
import PublicPageWrapper from 'components/PublicPagesWrapper'

import logo from 'images/guigo_partners_black.svg'

import { useAuth } from 'context/auth-context'
import { Link, FormContainer } from './styles'
import theme from 'styles/theme'
import { toast } from 'react-toastify'

const Login = () => {
  const { login } = useAuth()
  const [isSubmiting, setIsSubmiting] = useState(false)

  const handleLogin = useCallback(async values => {
    try {
      setIsSubmiting(true)
      await login(values)
    } catch (err) {
      console.log(err)
      const { detail } = err.response.data
      if (detail) {
        toast.error(detail)
      } else {
        toast.error('Email ou senha inválidos')
      }
    } finally {
      setIsSubmiting(false)
    }
  }, [])

  return (
    <PublicPageWrapper>
      <Card minWidth={384} p={32} bg='white'>
        <Flex flexDirection='column' alignItems='center' justifyContent='center' mb={24}>
          <Box mb={32}>
            <img src={logo} />
          </Box>
          <Box mb={32}>
            <SemiTitle color={theme.colors.turquoises.T300} as='h3'>
              Entrar
            </SemiTitle>
          </Box>
          <Formik initialValues={{ email: '', password: '' }} onSubmit={handleLogin}>
            <FormContainer>
              <TextField name='email' type='email' label='email' placeholder='Digite seu e-mail' mb={32} />
              <TextField
                name='password'
                type='password'
                label='Senha'
                placeholder='Digite sua senha'
                width={1}
                mb={48}
              />
              <Flex width={1} justifyContent='center'>
                <Button size='auto' disabled={isSubmiting}>
                  {isSubmiting ? <Loader /> : 'Entrar'}
                </Button>
              </Flex>
            </FormContainer>
          </Formik>
        </Flex>
        <Flex flexDirection='column'>
          <Link to='/forgot-password'>Esqueceu a senha?</Link>
          <Text color={theme.colors.blues.A800}>
            Ainda não possui cadastro? <Link to='/sign-up'>Faça seu pré-cadastro</Link>
          </Text>
        </Flex>
      </Card>
    </PublicPageWrapper>
  )
}

export default Login
